const usersAnalysis = {
  icon: 'PieChartIcon',
  title: 'Users Analysis',
  subtitle: 'Live numbers across all sources.',
  goto: 'analysis',
  gotoLabel: 'Back to Analysis',
  gotoIcon: 'ArrowLeftIcon',
}

export default usersAnalysis
